import $ from '@ali/tarzan-zepto';
import BaseUI from '../../../component/baseui/index';
import util from '../../../lib/util';
import tpl from './tpl.html';
import './style.scss';


const TAP = util.isPC() ? 'click' : 'tap';

export default function robot(data) {
  const app = this;
  const param = {
    name: 'textlink',
    mid: data.mid,
    isFollow: data.isFollow,
    content: tpl.render(data),
  };
  const $node = $(BaseUI.msg(param));

  $node.find('.textlink-link').on(TAP, () => {
    const link = document.createElement('a');
    if (data.link.link) {
      link.href = data.link.link;
    } else if (data.link.link_config) {
      link.href = app.param[data.link.link_config];
    }
    link.target = '_blank';
    link.click();
    $(link).remove();
  });

  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/textlink/index.js